<template>
	<footer class="sticky w-full border-t-2 top-full bg-white">
		<div class="relative max-w-6xl px-3 mx-auto lg:flex">
			<button
				v-if="isMobile"
				class="absolute right-3 top-2"
				@click="toggleFooter"
			>
				<img
					src="@/assets/icons/arrow-down-black.svg"
					class="my-auto"
					:class="{ 'transform rotate-180': expandedMobile }"
					alt="collapse footer arrow"
					width="16"
					height="16"
				>
			</button>
			<div class="w-full text-left md:mt-0 lg:py-4 xl:mx-4 lg:w-1/4">
				<div v-track-event.click="LOGO_FOOTER_CLICK">
					<router-link to="/">
						<WwLogo
							full
							class="my-2 md:mx-0"
						/>
					</router-link>
				</div>
				<div
					v-if="!isMobile"
					class="w-1/4 lg:w-full"
				>
					<div class="pt-2">
						<div class="flex justify-between w-32 mx-auto">
							<a
								v-for="link in SOCIAL_LINKS"
								:key="link.name"
								targe="_blank"
								rel="noopener"
								:href="link.url"
							>
								<img
									:src="link.imgSrc"
									:alt="link.alt"
									width="18"
									height="18"
								>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="isExpandedMobileAccordion"
				class="flex flex-col justify-around w-full py-2 md:flex-row"
			>
				<div class="mx-16 text-left border-b-2 lg:pt-4 md:mx-0 md:border-b-0">
					<button
						class="flex justify-between w-full py-2 font-bold md:text-lg"
						@click="toggleCompanyLinks"
					>
						<span class="pr-2">
							Company
						</span>
						<img
							v-if="isMobile"
							src="@/assets/icons/arrow-down-black.svg"
							class="inline-block my-auto"
							:class="{ 'transform rotate-180': expandedCompanyLinks }"
							alt="collapse footer arrow"
							width="16"
							height="16"
						>
					</button>

					<div
						v-if="isExpandedCompanyAccordion"
						class="text-base text-gray-500"
					>
						<ul
							v-for="link in COMPANY_LINKS"
							:key="link.name"
						>
							<li class="py-1">
								<router-link
									class="hover:text-green-500"
									:to="{ name: link.link }"
								>
									{{ link.name }}
								</router-link>
							</li>
						</ul>
					</div>
				</div>

				<div
					v-if="isExpandedMobileAccordion"
					class="mx-16 text-left border-b-2 lg:pt-4 md:mx-0 md:border-b-0"
				>
					<button
						class="flex justify-between w-full py-2 font-bold md:text-lg"
						@click="toggleBusinessLinks"
					>
						<span class="pr-2">
							Business
						</span>
						<img
							v-if="isMobile"
							src="@/assets/icons/arrow-down-black.svg"
							class="inline-block my-auto"
							:class="{ 'transform rotate-180': expandedBusinessLinks }"
							alt="collapse footer arrow"
							width="16"
							height="16"
						>
					</button>
					<div
						v-if="isExpandedBusinessAccordion"
						class="text-gray-500"
					>
						<ul
							v-for="link in BUSINESS_LINKS"
							:key="link.name"
						>
							<li class="py-1">
								<router-link
									class="hover:text-green-500"
									:to="{ name: link.link }"
								>
									{{ link.name }}
								</router-link>
							</li>
						</ul>
					</div>
				</div>

				<div
					v-if="!isMobile"
					class="pt-4"
				>
					<NewsletterForm
						:is-footer-form="true"
						class="w-48 font-bold"
					/>
				</div>
			</div>
		</div>
		<div
			v-if="isExpandedMobileAccordion"
			class="border-t-2"
		>
			<div class="justify-between max-w-5xl p-3 m-auto text-xs text-gray-500 md:flex">
				<div>
					<router-link
						class="hover:text-green-500"
						to="/privacy"
					>
						Privacy Policy
					</router-link>
					|
					<router-link
						class="hover:text-green-500"
						to="/terms"
					>
						Terms of Service
					</router-link>
					|
					<router-link
						class="hover:text-green-500"
						to="/copyright"
					>
						Copyright Policy
					</router-link>
				</div>
				<div>
					&copy; Copyright 2012-{{ year }} {{ APP_META.DOMAIN_NAME }}. All rights reserved.
				</div>
			</div>
		</div>
		<div class="z-10">
			<WwChat v-if="showChat" />
		</div>
	</footer>
</template>

<script>
import { mapState } from 'vuex'

import WwLogo from '@/components/multiUse/WwLogo.vue'
import {
	BUSINESS_LINKS,
	COMPANY_LINKS,
	SOCIAL_LINKS
} from '@/constants/footerLinks.js'
import { APP_META } from '@/constants/index.js'
import { LOGO_FOOTER_CLICK } from '@/constants/logging/clickEvents.js'
export default {
	components: {
		WwLogo,
		NewsletterForm: () => import('@/components/multiUse/NewsletterForm.vue'),
		WwChat: () => import('@/components/singleUse/WwChat.vue')
	},
	data() {
		return {
			isMounted: false,
			COMPANY_LINKS,
			BUSINESS_LINKS,
			SOCIAL_LINKS,
			expandedMobile: false,
			expandedCompanyLinks: false,
			expandedBusinessLinks: false,
			LOGO_FOOTER_CLICK,
			APP_META
		}
	},
	computed: {
		mediaMatch () {
			return this.$store.state.mediaMatch
		},
		isMobile() {
			return this.mediaMatch === 'sm' || this.mediaMatch === 'xs'
		},
		staticFooter () {
			return this.mediaMatch !== 'sm' && this.mediaMatch !== 'xs'
		},
		year () {
			return new Date().getFullYear()
		},
		userAgent() { return navigator && navigator.userAgent },
		isBot() { return (/crawl|googlebot|slurp|spider|bingbot|tracker|click|parser|applebot|yandex|semrushbot|ahrefsbot|insights|lighthouse/.test(this.userAgent.toLowerCase())) },
		showChat() {
			return this.isMounted && !this.isBot && this.auth && this.auth.showChat
		},
		...mapState({
			auth: state => state.auth
		}),
		logoWidth() {
			return this.isMobile ? 125 : 200
		},
		isExpandedMobileAccordion() {
			return !(this.isMobile && !this.expandedMobile)
		},
		isExpandedCompanyAccordion() {
			return !(this.isMobile && !this.expandedCompanyLinks)
		},
		isExpandedBusinessAccordion() {
			return !(this.isMobile && !this.expandedBusinessLinks)
		}
	},
	mounted() {
		this.isMounted = true
	},
	methods: {
		async toggleFooter() {
			await this.toggleExpandedMobile()
			window.scrollTo(0, document.body.scrollHeight)
		},
		async toggleCompanyLinks() {
			await this.toggleExpandedCompanyLinks()
			window.scrollTo(0, document.body.scrollHeight)
		},
		async toggleBusinessLinks() {
			await this.toggleExpandedBusinessLinks()
			window.scrollTo(0, document.body.scrollHeight)
		},
		toggleExpandedMobile() {
			this.expandedMobile = !this.expandedMobile
		},
		toggleExpandedCompanyLinks() {
			this.expandedCompanyLinks = !this.expandedCompanyLinks
		},
		toggleExpandedBusinessLinks() {
			this.expandedBusinessLinks = !this.expandedBusinessLinks
		}
	}
}
</script>
